<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col
        lg="7"
        class="d-none d-lg-flex align-items-center fixing-padding-login"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center">
          <b-img-lazy
            :src="require('@/assets/images/logo/login.jpg')"
            alt="Login V2"
            class="imagen-logo-custom"
            width="450"
            style="border-radius: 50%;"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="5"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
            Bienvenido a Medinet!
          </b-card-title>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <b-form-group
                label="Ambiente"
                label-for="login-ambiente"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Ambiente"
                  vid="ambiente"
                  rules="required"
                >
                  <b-form-select
                    id="login-ambiente"
                    v-model="selectedEnvironment"
                    :options="environmentOptions"
                    :state="errors.length > 0 ? false : null"
                    value-field="value"
                    text-field="text"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group
                label="Establecimiento"
                label-for="login-establecimiento"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Establecimiento"
                  vid="establecimiento"
                  rules="required"
                >
                  <b-form-select
                    id="login-establecimiento"
                    v-model="selectedEstablecimiento"
                    :options="establecimientoOptions"
                    :state="errors.length > 0 ? false : null"
                    value-field="value"
                    text-field="text"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- email -->
              <b-form-group
                label="Usuario"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Usuario"
                  vid="email"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="Usuario"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Contraseña</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Contraseña"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Contraseña"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                Iniciar sesión
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BCardTitle,
  BForm,
  BButton,
  BImgLazy,
  BFormSelect,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from "@/libs/axios";
import { establecimientosService } from '@/views/administracion/services'
import { API_ENVIRONMENTS, applyApiEnvironment, getApiEnvironmentOptions, getStoredApiEnvironment } from '@/shared/helpers'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,

    BCardTitle,
    BForm,
    BButton,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    BImgLazy,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      required,
      email,
      selectedEnvironment: getStoredApiEnvironment(),
      selectedEstablecimiento: null,
      environmentOptions: getApiEnvironmentOptions(),
      establecimientoOptions: [{ value: null, text: 'Seleccione un establecimiento' }],
    }
  },
  computed: {

    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },


    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },


  },


  mounted() {
    applyApiEnvironment(this.selectedEnvironment)
    this.loadEstablecimientos()
  },

  watch: {
    selectedEnvironment(newValue) {
      applyApiEnvironment(newValue || API_ENVIRONMENTS.prod.value)
      this.selectedEstablecimiento = null
      this.loadEstablecimientos()
    },
    selectedEstablecimiento(newValue) {
      if (!newValue) {
        localStorage.removeItem('establecimientoSeleccionado')
        return
      }

      const establecimiento = this.establecimientoOptions.find(e => e.value === newValue)
      if (establecimiento) {
        localStorage.setItem('establecimientoSeleccionado', JSON.stringify(establecimiento))
      }
    },
  },



  methods: {
    async loadEstablecimientos() {
      const stored = localStorage.getItem('establecimientoSeleccionado')
      const storedParsed = stored ? JSON.parse(stored) : null

      let options = []
      try {
        options = await establecimientosService.getForSelect()
      } catch (error) {
        this.establecimientoOptions = [{ value: null, text: 'Seleccione un establecimiento' }]
        return
      }
      const formatted = [{ value: null, text: 'Seleccione un establecimiento' }, ...options]
      this.establecimientoOptions = formatted

      if (storedParsed && options.find(opt => opt.value === storedParsed.value || opt.id === storedParsed.id)) {
        this.selectedEstablecimiento = storedParsed.value || storedParsed.id
        return
      }

      // No stored selection; keep placeholder until user selects
      this.selectedEstablecimiento = null
    },

    login() {
      this.$refs.loginForm.validate().then(success => {
         
        if (success) {
          const mutation = `
            mutation tokenAuth(
              $username: String!, 
              $password: String!
            ) {
              tokenAuth(
                username: $username, 
                password: $password
              ) {
                token
                user {
                  id
                  username
                }
                detalleUsuario {
                  token
                  avatar
                  establecimiento {
                    id
                    Descripcion
                    uniCodigo
                  }
                  avatarruta
                  persona {
                    token
                    correo
                    identificacion
                    primerNombre
                    primerApellido
                    segundoApellido
                    segundoNombre
                    doctorSet {
                    id
                    }
                  }
                }
                permisos
                listaRoles {
                  codigo
                }
              }
            }
          `;
          const variables = {
            username: this.userEmail,
            password: this.password
          };
          axios.post('api', { query: mutation, variables })
            .then(response => {
              const data = response.data.data;
              const userDetails = data.tokenAuth.detalleUsuario;
              userDetails.roles = data.tokenAuth.listaRoles;

              const selectedId = this.selectedEstablecimiento;
              const userEstablecimientoId = userDetails.establecimiento?.id;

              if (!selectedId || `${selectedId}` !== `${userEstablecimientoId}`) {
                this.$swal({
                  title: 'Establecimiento incorrecto',
                  text: 'El usuario no pertenece al establecimiento seleccionado.',
                  icon: 'error',
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Aceptar'
                });
                return;
              }

              data.tokenAuth.user.token = data.tokenAuth.token;
              axios.defaults.headers.common.Authorization = `JWT ${data.tokenAuth.token}`;

              localStorage.setItem('permisos', JSON.stringify(data.tokenAuth.permisos));
              localStorage.setItem('detalleusuario', JSON.stringify(userDetails));
              this.$store.commit('setDetalleUsuario', userDetails);

              const dataSession = {
                ...data.tokenAuth.user,
                code: new Date().getTime()
              }

              localStorage.setItem('usuario', JSON.stringify(dataSession));

              this.$store.commit('setUsuario', data.tokenAuth.user);
              this.$router.push({ name: 'home' });
            })
            .catch(error => {
              // Aquí es donde manejas el error de inicio de sesión
              this.$swal({
                title: 'Error de Autenticación',
                text: 'Usuario o contraseña incorrectos. Por favor, intenta de nuevo.',
                icon: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Aceptar'
              });
              this.loading = false;
            });
        }
      });
    },

    showError(error) {
      const error_dict = JSON.parse(JSON.stringify(error))
      if (error_dict.response.errors.length > 0) {
        const errores = error_dict.response.errors
        if (errores) {
          this.$swal({
            title: 'Error!',
            text: errores[0].message,
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
            confirmButtonText: 'Aceptar',
          })
        }
      } else {
        this.$swal({
          title: 'Error!',
          text: 'Ocurrió un error, intente nuevamente.',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
          confirmButtonText: 'Aceptar',
        })
      }
    },
    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Form Submitted',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
